import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {GroupActivity} from "../../models/groupActivity";
import {GroupActivityService} from "../service/groupActivity.service";

@Injectable()
export class GroupActivityResolve implements Resolve<GroupActivity> {
    constructor(private groupActivityService: GroupActivityService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<GroupActivity> {
        return this.groupActivityService.getById(route.params.id);
    }
}
